const getCellActions = (settings) => {
  return {
    removeTrial: (value, valueKey, dataObject, controller) => {
      settings.addPostToQue({
        data: { trial: dataObject._id, concat: dataObject.concat },
        update: true,
        overrideEndpoint: ['/rt/savePriorityTrial/', settings.trialInstance, '/removeTrial/'],
        cleanup: () => {
          settings.handleDataRefresh('priorityTrials', true);
          controller.handlingUpdate = true;
        }
      });
    },
    removePITrial: (value, valueKey, dataObject, controller) => {
      settings.addPostToQue({
        update: true,
        overrideEndpoint: ['/rt/console/deleteNct/', dataObject._id, `/${settings.trialInstance}/`],
        method: 'get',
        cleanup: () => {
          settings.handleDataRefresh('getTrials', true);
          controller.handlingUpdate = true;
        }
      });
    },
    customDataReviewed: (value, valueKey, dataObject, controller) => {
      settings.addPostToQue({
        data: {
          nct: dataObject._id,
          reviewed: value,
          user: {...settings.auth, instance: settings.trialInstance},
          title: dataObject.brief_title
        },
        update: true,
        endPoint: 'saveReviewed',
        cleanup: () => {
          settings.handleDataRefresh('allTrials');
          controller.handlingUpdate = true;
        }
      })
    },
    reviewedSwitch: (value, valueKey, dataObject, controller) => {
      const queObject = {
        data: {
          nct: dataObject._id,
          concat: dataObject.concat,
          reviewed: value,
          user: {...settings.auth, instance: settings.trialInstance},
        },
        update: true,
        endPoint: 'saveReviewed',
        cleanup: () => {
          console.log('hit2')
          settings.handleDataRefresh('allTrials', true);
          controller.handlingUpdate = true;
        }
      };
      settings.addPostToQue(queObject);
    },
    approveSwitch: (value, valueKey, dataObject, controller) => {
      // console.log('approveSwitch called', value,dataObject, controller, valueKey)
      settings.addPostToQue({
        data: {
          display: true,
          nct: dataObject._id,
          title: dataObject.brief_title,
          concat: dataObject.concat,
          approved: value,
          user: {...settings.auth, instance: settings.trialInstance},
          instance: settings.trialInstance
        },
        update: true,
        endPoint: 'saveExcluded',
        cleanup: () => {
          settings.handleDataRefresh('allTrials', true);
          controller.handlingUpdate = true;
        }
      })
    },
    priorityTrialSwitch: (value, valueKey, dataObject, controller) => {
     // console.log('priorityTrialSwitch called value', value, dataObject)
      const subRoute = value ? '/newTrial/' : '/removeTrial/';
      settings.addPostToQue({
        data: { trial: dataObject._id, concat: dataObject.concat},
        update: true,
        overrideEndpoint: ['/rt/savePriorityTrial/', settings.trialInstance, subRoute],
        cleanup: () => {
          settings.handleDataRefresh('allTrials', true);
          controller.handlingUpdate = true;
        }
      });
    }
  }
}

export default getCellActions;
